export default function attachAtlas(key?: string) {
  const atlas = {
    appId: key || 'q4mjj4och5',
    v: 2,
    q: [] as any,
    identify: function (payload: any) {
      this.q.push(['identify', payload])
    },
    start: function (payload: any) {
      const currentAtlas = this as any
      currentAtlas.autorun = payload || !0
    },
  } as any

  const atlasWindow = window as any
  atlasWindow.Atlas = atlas
  const n = document.createElement('script')
  n.async = !0
  n.src = 'https://app.getatlas.io/client-js/atlas.bundle.js'
  const s = document.getElementsByTagName('script')[0]
  const parentNode = s.parentNode
  parentNode?.insertBefore(n, s)
}
